import { getAlertTitleUtilityClass } from "@mui/material";
import { prodapiAxiosClient } from "../api/prodApiClient";

const newTwinPack = (cameras) => {
    return prodapiAxiosClient
    .post("/api/v1/twinPacks",{cameras: cameras})
}


const palletApi = { newTwinPack }
export default palletApi;